import { FormattedMessage } from "react-intl";
import { Heading2 } from "../../../components/value-cssmodules/TextComponent";
import { Link } from "react-router-dom";
import styles from "./NewArrivals.module.scss";
import { Grid } from "semantic-ui-react";
import TextOnPictureBig from "../../../components/TextOnPicture/TextOnPictureBig";
import TextOnPictureSmall from "../../../components/TextOnPicture/TextOnPictureSmall";
import { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "../../../components/Spinner";

interface NewArrivalProducts {
    path: string;
    url: string;
    title: string;
    price: string;
}

const NewArrivals = () => {
    const [latestProducts, setLatestProducts] = useState<NewArrivalProducts[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {

        const fetchLatestPatterns = async () => {
            setLoading(true)
            try {
               const res = await axios.get("/api/patterns/new-arrivals")
                setLatestProducts(res.data.patterns)
            } catch (error) {
                console.error("failed to fetch", error)
            } finally {
                setLoading(false)
            }

        }
        fetchLatestPatterns();
    }, []);

    if (loading) return <Spinner />

    return (
        <div>

            <Heading2>
                <FormattedMessage
                    id="home.newArrivals"
                    defaultMessage="New Arrivals" />
            </Heading2>

            <Grid>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    {latestProducts.length > 0 && (
                        <TextOnPictureBig data={latestProducts[0]} />
                    )}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    {latestProducts.slice(1).map((product: any, i: number) => (
                        <TextOnPictureSmall
                            key={`${product.title}-${i}`}
                            product={product}
                        />
                    ))}
                </Grid.Column>
                <Grid.Column textAlign="center" mobile={16} tablet={16} computer={16}>
                    <Link to="/patterns?categories=newArrivals" className={styles.link}>
                        <button className={styles.button}>
                            <FormattedMessage
                                id="nav.invitationabutton"
                                defaultMessage="Zobacz wszystkie nowości"
                            />
                        </button>
                    </Link>
                </Grid.Column>
            </Grid>
        </div>
    )
}

export default NewArrivals;